import React, { ReactNode, useState } from 'react';
import { Briefcase, Menu, X, Sun, Moon, Facebook, MapPin, Phone, Mail } from 'lucide-react'; // Added Facebook, MapPin, Phone, Mail
import Button from '../Ui/Button';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/wehirelogo.jpeg';

import mdProfile from '../assets/md_image.jpeg';
import { ShieldCheck } from 'lucide-react';


interface PublicLayoutProps {
    children: ReactNode;
    theme: 'light' | 'dark';
    mobileMenuOpen: boolean;
    setMobileMenuOpen: (open: boolean) => void;
    toggleTheme: () => void;
    setTheme: (theme: 'light' | 'dark') => void;
}

const PublicLayout = ({
    children,
    theme,
    mobileMenuOpen,
    setMobileMenuOpen,
    toggleTheme,
    setTheme
}: PublicLayoutProps) => {
    const navigate = useNavigate();
    const [policyOpen, setPolicyOpen] = useState(false);
    const [policyType, setPolicyType] = useState<'privacy' | 'terms'>('privacy');

    // Facebook Link Constant
    const FACEBOOK_URL = "https://www.facebook.com/share/1CYSHEYMNJ/?mibextid=wwXIfr";

    return (
        <div className={`min-h-screen font-sans transition-colors duration-300 ${theme === 'light' ? 'bg-black text-white' : 'bg-zinc-50 text-zinc-900'}`}>

            {/* Navbar */}
            <nav className={`sticky top-0 z-50 transition-colors duration-300 ${theme === 'light' ? 'bg-black/80 border-zinc-800' : 'bg-white/80 border-zinc-200'} border-b backdrop-blur-md`}>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-20 items-center">
                        <div className="flex items-center cursor-pointer group" onClick={() => navigate('/')}>
                            <div className="w-10 h-10  flex items-center justify-center mr-3">
                                <img
                                    src={logo}
                                    alt="WeHireIndia"
                                    className="h-10 w-10 rounded-full object-cover border border-zinc-300"
                                />
                            </div>
                            <span className={`font-black text-xl tracking-tight ${theme === 'dark' ? 'text-black' : 'text-zinc-900'}`}>WeHire<span className="text-violet-600">India</span></span>
                        </div>

                        {/* Desktop Menu */}
                        <div className="hidden md:flex items-center space-x-8">
                            <button onClick={() => navigate('/home')} className="text-sm font-bold text-zinc-900 hover:text-violet-600">Home</button>

<button onClick={() => document.getElementById('about')?.scrollIntoView({behavior:'smooth'})}
  className="text-sm font-bold text-zinc-900 hover:text-violet-600"
>
  About
</button>

<button 
  onClick={() => document.getElementById('service')?.scrollIntoView({behavior:'smooth'})}
  className="text-sm font-bold text-zinc-900 hover:text-violet-600"
>
  Services
</button>

<button 
  onClick={() => document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})}
  className="text-sm font-bold text-zinc-900 hover:text-violet-600"
>
  Contact
  </button>
  <button onClick={() => navigate('/admin/login')} className="text-sm font-bold text-zinc-900 hover:text-violet-600">Admin</button>
   <Button onClick={() => navigate('/apply')} 
  className="relative text-sm font-bold bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-600 hover:text-white shadow-md hover:shadow-xl hover:shadow-blue-500/20 animate-bounce hover:animate-none transition-all duration-300 px-8 py-3 rounded-full overflow-hidden">
  <span className="absolute inset-0 bg-blue-600/10 animate-pulse"></span>
  Apply Now
</Button>
</div>
                        {/* Mobile Menu Button */}
                        <div className="flex items-center gap-4 md:hidden">
                            
                            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-zinc-1000 dark:text-voilet hover:text-violet-600">
                                {mobileMenuOpen ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu Dropdown */}
                {mobileMenuOpen && (
                    <div className={`md:hidden border-t ${theme === 'dark' ? 'bg-zinc-900 border-zinc-800' : 'bg-white border-zinc-100'} shadow-2xl`}>
                        <div className="px-4 pt-4 pb-6 space-y-2">
                            <button onClick={() => { navigate('/'); setMobileMenuOpen(false); }}
                                className={`block w-full text-left px-4 py-3 rounded-xl font-bold ${theme === 'dark' ? 'text-zinc-300 hover:bg-zinc-800' : 'text-zinc-600 hover:bg-zinc-50'}`}>Home
                            </button>
                            <button onClick={() => { navigate('/apply'); setMobileMenuOpen(false); }}
                                className={`block w-full text-left px-4 py-3 rounded-xl font-bold ${theme === 'dark' ? 'text-zinc-300 hover:bg-zinc-800' : 'text-zinc-600 hover:bg-zinc-50'}`}
                            >
                                For Seekers
                            </button>
                            <button
                                onClick={() => { navigate('/recruiters'); setMobileMenuOpen(false); }}
                                className={`block w-full text-left px-4 py-3 rounded-xl font-bold ${theme === 'dark' ? 'text-zinc-300 hover:bg-zinc-800' : 'text-zinc-600 hover:bg-zinc-50'}`}
                            >
                                For Recruiters
                            </button>
                            <button
                                onClick={() => { navigate('/status'); setMobileMenuOpen(false); }}
                                className={`block w-full text-left px-4 py-3 rounded-xl font-bold ${theme === 'dark' ? 'text-zinc-300 hover:bg-zinc-800' : 'text-zinc-600 hover:bg-zinc-50'}`}
                            >
                                Check Status
                            </button>
                            <div className={`border-t my-4 pt-4 ${theme === 'dark' ? 'border-zinc-800' : 'border-zinc-100'}`}>
                                <button
                                    onClick={() => { navigate('/admin/login'); setMobileMenuOpen(false); }}
                                    className="block w-full text-left px-4 py-3 text-sm font-bold text-zinc-400 hover:text-violet-500"
                                >
                                    Admin Portal
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </nav>

            {/* Main Content */}
            <main className="relative">
                {children}
            </main>

{/* --- MANAGING DIRECTOR PROFILE SECTION --- */}

<section className={`py-20 px-6 ${theme === 'dark' ? 'bg-zinc-900/50' : 'bg-white'}`}>
  <div className="max-w-6xl mx-auto">
    {/* ONLY THIS CARD HAS GRADIENT */}
    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-violet-600 to-fuchsia-500 border border-transparent p-8 md:p-12 flex flex-col md:flex-row items-center gap-12 shadow-xl">
      
      {/* MD Image */}
      <div className="w-full md:w-1/3 flex-shrink-0 relative flex justify-center">
        <div className="relative w-56 h-56 md:w-72 md:h-72">
          <div className="absolute inset-0 bg-white/20 rounded-full blur-2xl opacity-30"></div>
          <img
            src={mdProfile}
            alt="Areful Mallick"
            className="relative w-full h-full object-cover rounded-full border-4 border-white/40 shadow-2xl"
          />
          <div className="absolute bottom-4 right-4 bg-white text-violet-600 p-2 rounded-full shadow-lg z-20">
            <ShieldCheck className="w-6 h-6" />
          </div>
        </div>
      </div>

      {/* MD Text Content */}
      <div className="w-full md:w-2/3 text-center md:text-left space-y-6">
        <div>
          <h2 className="text-3xl md:text-4xl font-black mb-2 text-white">
            Areful Mallick
          </h2>
          <p className="font-bold uppercase tracking-wider text-sm mb-4 text-white/90">Managing Director & Chairman</p>
        </div>
        <div className="space-y-4">
          <p className="text-base md:text-lg italic text-white/90 leading-relaxed">
            "Our mission is to create meaningful job opportunities across India while empowering businesses with the right talent and strategic support. We believe that every deserving individual deserves the right opportunity."
          </p>
          <p className="text-base font-medium text-white">
            Creating careers. Empowering businesses. Building India—one opportunity at a time.
          </p>
        </div>
        <div className="pt-6 border-t border-white/20">
          <p className="text-sm text-white/80">
            Leading We Hire Pvt Ltd in Staffing Solutions, Payroll Management, Capability Building, and Real Estate Consultancy.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

            {/* Footer */}
<footer className="py-16 px-6 mt-auto border-t bg-gradient-to-r from-violet-600 to-fuchsia-500 border-transparent text-white">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-12">

                        {/* Column 1: Brand & CIN */}
                        <div className="space-y-4">
                            <div className="flex items-center gap-2">
                                <img src={logo} alt="WeHireIndia" className="h-10 w-10 rounded-full object-cover border border-zinc-300" />
                                <span className={`font-bold text-xl ${theme === 'dark' ? 'text-white' : 'text-zinc-900'}`}>
                                    WeHireIndia
                                </span>
                            </div>
                            <p className="text-sm leading-relaxed text-white">
                                Leading manpower solutions and real estate consultancy based in across all over India.
                            </p>
                            <div className="pt-2">
                            <span className={`text-xs font-mono px-2 py-1 ${theme === 'dark' ? 'text-white' : 'text-zinc-900'}`}>

                                    CIN: U70200WB2024PTC272614
                                </span>
                            </div>
                            {/* Social Media Link */}
                            <div className="pt-4">
                                <a
                                    href={FACEBOOK_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 transition-colors text-white hover:text-violet-500 font-semibold transition-colors"
                                >
                                    <Facebook className="w-5 h-5" />
                                    <span>Follow us on Facebook</span>
                                </a>
                            </div>
                        </div>

                        {/* Column 2: Contact Info */}

<div id="contact" className="space-y-4">
  <h4
    className={`font-bold uppercase tracking-wider text-sm ${theme === 'dark' ? 'text-zinc-200' : 'text-zinc-800'}`}
  >
    Contact Us
  </h4>
                            <div className="space-y-3 text-sm">
                                <p className="flex items-center gap-3">
                                    <Phone className="w-4 h-4 text-white-600 shrink-0" />
                                    <a
                                        href="tel:03366183035"
                                        className="hover:text-white transition-colors text-white"
                                    >
                                        033 6618 3035
                                    </a>
                                </p>

                                <p className="flex items-center gap-3">
                                    <Mail className="w-4 h-4 text-white-600 shrink-0" />
                                    <a
                                        href="mailto:support@wehireindia.com"
                                        className="hover:text-white-500 transition-colors text-white"
                                    >
                                        support@wehireindia.com
                                    </a>
                                </p>

                                {/* FIXED ADDRESS */}
                                <p className="flex items-center gap-3">
                                    <MapPin className="w-4 h-4 text-white-600 shrink-0"/>
                                    <a href="https://www.google.com/maps/search/?api=1&query=WE+HIRE+PRIVATE+LIMITED+IRIS+Building+Newtown+Kolkata"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-white-500 transition-colors leading-relaxed text-white"
                                    >
                                        Shop No-C, IRIS Building, beside Delhi Public School Megacity,
                                        Newtown, Mahammadpur, West Bengal 700135
                                    </a>
                                </p>
                            </div>
                        </div>

                        {/* Column 3: Map - FIXED */}
                        <div className="w-full h-48 rounded-2xl overflow-hidden border border-zinc-200 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-900 relative">
                            <iframe
                                key={window.location.pathname + '-map'}
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d139034.863547645!2d88.3306695478975!3d22.570713988466114!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a020b86c0a23671%3A0x609860a8da88959c!2sWE%20HIRE%20PRIVATE%20LIMITED!5e1!3m2!1sen!2sin!4v1770534728847!5m2!1sen!2sin"
                                width="100%"
                                height="100%"
                                style={{ border: 0, display: 'block', minHeight: '192px' }}
                                allowFullScreen
                                loading="eager"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Office Location"
                            ></iframe>
                        </div>
                    </div>

                    <div className={`pt-8 border-t ${theme === 'light' ? 'border-zinc-900' : 'border-zinc-100'} flex flex-col md:flex-row justify-between items-center gap-6 transition-colors text-white`}>
                        <p className="text-xs">© 2026 We Hire Private Limited. All rights reserved.</p>
                        <div className="flex gap-6 text-xs font-semibold">
                            <span onClick={() => { setPolicyType('privacy'); setPolicyOpen(true); }} className="hover:text-violet-600 cursor-pointer transition-colors text-white">
                                Privacy Policy
                            </span>
                            <span onClick={() => { setPolicyType('terms'); setPolicyOpen(true); }} className="hover:text-violet-600 cursor-pointer transition-colors text-white">
                                Terms of Service
                            </span>
                        </div>
                        {policyOpen && (
                            <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                                <div className={`w-full max-w-3xl max-h-[85vh] rounded-2xl shadow-2xl overflow-hidden ${theme === 'dark' ? 'bg-zinc-900 text-zinc-200' : 'bg-white text-zinc-800'}`}>
                                    <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-200 dark:border-zinc-800">
                                        <h2 className="text-lg font-bold">{policyType === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}</h2>
                                        <button onClick={() => setPolicyOpen(false)} className="p-2 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800">
                                            <X className="h-5 w-5" />
                                        </button>
                                    </div>
                                    <div className="px-6 py-5 overflow-y-auto text-sm leading-relaxed space-y-4">
                                        {policyType === 'privacy' ? (
                                            <>
                                                <p>We Hire Private Limited (“WeHireIndia”) is committed to protecting the privacy of all users.</p>
                                                <p>We may collect personal information such as name, phone number, email address, resume details, and job preferences solely for recruitment and consultancy purposes.</p>
                                                <p><strong>CIN:</strong> U70200WB2024PTC272614 <br /><strong>Contact:</strong> 033 6618 3035 | support@wehireindia.com</p>
                                                <p>We do not sell or share personal data with unauthorized third parties.</p>
                                            </>
                                        ) : (
                                            <>
                                                <p>By accessing or using WeHireIndia services, you agree to comply with these Terms of Service.</p>
                                                <p>WeHireIndia provides manpower solutions and real estate consultancy. Final hiring decisions are solely the responsibility of employers.</p>
                                                <p>All logos, content, and data belong to We Hire Private Limited. Unauthorized use is strictly prohibited.</p>
                                                <p>These terms are governed by the laws of India.</p>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PublicLayout;